import RoutesMap from "../../route_control/RouteControl"
import {
    InwardList,
    StockAvailabilityList,
    PricingList,
    OutwardList,
} from "../../pages/inventory"

export const InventoryImport = {
    RoutesMap,
    InwardList,
    StockAvailabilityList,
    PricingList,
    OutwardList,
}